import { biLoggerFactory } from 'wix-private';

const msid = 'd7efbb31-1a4c-4196-acf9-3937bbd79cc2'; //replace the value between quotes with your site msid value

const biGroupsLoggers = {
    19: biLoggerFactory('logo-hp-new', 19, { msid }),
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}